<slider
  [pagination]="true"
  [navigation]="false"
  [breakpoints]="{
    '0': { slidesPerView: 2, spaceBetween: 8 },
    '900': { slidesPerView: 2, spaceBetween: 12 },
    '1190': { slidesPerView: 3, spaceBetween: 16, pagination: false }
  }">
  @for (user of users(); track user.uid) {
    <ng-template appSlideItem>
      <kpis-summary-card [user]="user"></kpis-summary-card>
    </ng-template>
  }
</slider>
